<template>
  <div>
    <div
      style="height:120px; width:100%; overflow-y:auto; background-color:#FFFFFF; text-align:left; padding:10px; border-radius: 3px;"
    >
      <li
        class="chat text-base"
        v-for="(item,index) in board"
        :key="index"
        style="list-style: none;"
      >
        <a class="item-image pr-1">
          <img class="mr-1" :src="item.image" width="30" height="30" />
        </a>
        <p class="p-1 d-inline">
          <B>{{item.name}}</B>
          {{item.message}}
        </p>
      </li>
    </div>
  </div>
</template>
<script>
import firebase from "firebase/app";

export default {
  name: "Chat",
  props: ["selectedSession"],
  data() {
    return {
      board: [],
      message: "",
      user: {},
      eventInfo: ""
    };
  },
  watch: {
    selectedSession() {
      this.listen();
    }
  },
  created() {
    //認証
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        firebase
          .database()
          .ref("loginuser/" + user.uid)
          .on("value", snapshot => {
            this.user = snapshot.val();
          });
        this.listen();
      } else {
        this.$router.push("/");
      }
    });
    //認証
  },
  methods: {
    listen() {
      firebase
        .database()
        .ref("eventList/" + this.selectedSession)
        .on("value", snapshot => {
          this.eventInfo = snapshot.val();
        });
      firebase
        .database()
        .ref("eventList/" + this.selectedSession + "/messageBoard/")
        .on("value", snapshot => {
          if (snapshot.val()) {
            const rootList = snapshot.val();
            let list = [];

            Object.keys(rootList).forEach((val, key) => {
              list.push(rootList[val]);
            });
            var borad = list.reverse();
            this.board = borad;
          }
        });
    }
  }
};
</script>


<style>
.item-image img {
  border-radius: 50%;
  vertical-align: top;
  border: solid 2px rgb(245, 245, 232);
}
</style>